import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-24 bg-dark-bg relative border-y border-white/5" data-id="element-122">
      <div className="absolute inset-0 bg-grid-pattern opacity-30" data-id="element-123"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-5xl md:text-7xl font-teko font-bold text-white mb-4" data-id="element-126">
            IMAGINÁ VOLVER A SENTIRTE EN{' '}
            <span className="text-electric-blue text-glow-blue" data-id="element-127">CONTROL</span>
          </h2>
          <div className="w-24 h-1 bg-electric-blue mx-auto" data-id="element-128"></div>
        </motion.div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-129">
          {/* ANTES */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-panel-bg border border-red-500/20 rounded-2xl p-8 relative overflow-hidden group" data-id="element-130">
            <div className="absolute top-0 left-0 w-full h-1 bg-intense-red" data-id="element-131"></div>
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-intense-red/10 rounded-full blur-3xl" data-id="element-132"></div>

            <h3 className="text-3xl font-teko font-bold text-gray-400 mb-8 flex items-center gap-3" data-id="element-133">
              <span className="bg-black p-2 rounded-md border border-white/10" data-id="element-134">
                ANTES
              </span>
            </h3>

            <ul className="space-y-6" data-id="element-135">
              {['Ansiedad', 'Frustración', 'Inseguridad', 'Preocupación'].map((item, i) => <li key={i} className="flex items-center gap-4 text-xl font-medium text-gray-300" data-id="element-136">
                    <div className="bg-red-500/10 p-2 rounded-full" data-id="element-137">
                      <X className="w-6 h-6 text-intense-red" data-id="element-138" />
                    </div>
                    {item}
                  </li>)}
            </ul>
          </motion.div>

          {/* DESPUÉS */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-panel-bg to-black border border-electric-blue/40 rounded-2xl p-8 relative overflow-hidden box-glow-blue" data-id="element-139">
            <div className="absolute top-0 left-0 w-full h-1 bg-electric-blue" data-id="element-140"></div>
            <div className="absolute -right-10 -top-10 w-40 h-40 bg-electric-blue/20 rounded-full blur-3xl" data-id="element-141"></div>

            <h3 className="text-4xl font-teko font-bold text-white mb-8 flex items-center gap-3" data-id="element-142">
              <span className="bg-electric-blue text-black px-4 py-1 rounded-md" data-id="element-143">
                DESPUÉS
              </span>
            </h3>

            <ul className="space-y-6" data-id="element-144">
              {['Confianza', 'Tranquilidad', 'Mayor control', 'Mejores experiencias'].map((item, i) => <li key={i} className="flex items-center gap-4 text-2xl font-bold text-white" data-id="element-145">
                  <div className="bg-electric-blue/20 p-2 rounded-full" data-id="element-146">
                    <Check className="w-6 h-6 text-electric-blue" data-id="element-147" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}